const STYLE_ID = "emoji-flag-polyfill-font";

export function initEmojiFlagPolyfill() {
  if (document.getElementById(STYLE_ID)) {
    return;
  }

  const publicUrl = process.env.PUBLIC_URL || "";
  const style = document.createElement("style");
  style.id = STYLE_ID;
  style.textContent = `
    @font-face {
      font-family: "Twemoji Country Flags";
      src: url("${publicUrl}/fonts/TwemojiCountryFlags.woff2") format("woff2");
      font-weight: normal;
      font-style: normal;
      unicode-range: U+1F1E6-1F1FF, U+1F3F4;
    }
  `;
  document.head.appendChild(style);
}
